// Чистая логика определения смены версии бандла при трансфере.
// Единый источник правды для PublishDiffItem (что репортить наверх)
// и PublisherCampaigns (показывать ли модалку подтверждения).
//
// Намеренно без React/RTK зависимостей, чтобы покрыть юнит-тестами.

/**
 * По ответу /admin/transfer/difference вычисляет, меняется ли версия бандла
 * у СУЩЕСТВУЮЩЕЙ кампании (создание новой кампании трансфером сюда не относится —
 * это то же условие, по которому в PublishDiffItem рендерится LogItem
 * "bundle update to gX/vY by another transfer").
 *
 * @param {object|undefined} data ответ difference (oldCampaign/newCampaign/oldBundle/newBundle/generationsToUpdate)
 * @returns {{hasBundleUpdate: boolean, bundleId: (string|undefined), generations: Array<{generation:*, bundleVersion:*}>}}
 */
export function computeBundleUpdateInfo(data) {
    const adminAction = data == null || data.oldCampaign == null
        ? 'EVENT_CREATION_BY_TRANSFER'
        : 'EVENT_UPDATE';

    const hasBundleUpdate = data != null
        && adminAction !== 'EVENT_CREATION_BY_TRANSFER'
        && Array.isArray(data.generationsToUpdate)
        && data.generationsToUpdate.length > 0;

    return {
        hasBundleUpdate,
        bundleId: data && data.newBundle ? data.newBundle.id : undefined,
        generations: hasBundleUpdate
            ? data.generationsToUpdate.map(g => ({
                generation: g.generation,
                bundleVersion: g.bundleVersion
            }))
            : []
    };
}

/**
 * Из текущего выбора возвращает кампании, у которых меняется версия бандла
 * и обновление НЕ пропущено пользователем (Skip bundle update).
 *
 * @param {string[]} selectedList выбранные id кампаний
 * @param {Object.<string, {hasBundleUpdate: boolean}>} bundleUpdateInfo инфо по кампаниям
 * @param {string[]} skipBundleUpdateList id кампаний, для которых обновление бандла пропущено
 * @returns {string[]}
 */
export function getBundleUpdateCampaigns(selectedList, bundleUpdateInfo, skipBundleUpdateList) {
    const skip = skipBundleUpdateList || [];
    return (selectedList || []).filter(id =>
        bundleUpdateInfo[id] && bundleUpdateInfo[id].hasBundleUpdate && !skip.includes(id)
    );
}

/**
 * Форматирует список поколений в теги вида "g1/v49, g2/v3".
 * @param {Array<{generation:*, bundleVersion:*}>} generations
 * @returns {string}
 */
export function formatBundleUpdateTags(generations) {
    if (!generations || generations.length === 0) return '';
    return generations.map(g => `g${g.generation}/v${g.bundleVersion}`).join(', ');
}
